import {Worksheet} from 'exceljs';
import logo from 'src/modules/downloads/commons/images/logo.png';

const LOGO_EXTENSION = 'png';

export const printLogo = (worksheet: Worksheet) => {
    const workbook = worksheet.workbook;

    const logoId = workbook.addImage({
        base64: logo,
        extension: LOGO_EXTENSION,
    });

    worksheet.addImage(logoId, {
        tl: {col: 0, row: 0},
        ext: {width: 180, height: 30},
    });
};
